import { render } from "./FooterMenu.vue?vue&type=template&id=16ae3b4e&scoped=true"
import script from "./FooterMenu.vue?vue&type=script&scoped=true&lang=js"
export * from "./FooterMenu.vue?vue&type=script&scoped=true&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=16ae3b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ae3b4e"]])

export default __exports__